<template>
	<section class="main">
		<header class="panel-heading">
			<h3 class="panel-title">銷點申請查詢</h3>
		</header>
		<section class="panel panel-default" style="margin-bottom: 0px;">
			<header class="panel-heading" style="padding: 10px;">
				<div class="panel-actions" style="top: 7px;">
					<a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
				</div>
				<h4 class="panel-title">查詢條件</h4>
			</header>
			<div id="searchArea" class="panel-collapse collapse">
				<div class="panel-body">
					<div class="row form-group">
						<div class="col-md-12 ">
							<div class="col-md-4">
								<label class="col-md-4">學期</label>
								<div class="col-md-8">
									<select v-model="smtr" class="form-control">
										<option value="">--請選擇--</option>
										<option v-for="(year, index) in selectYear()" :key="index" :value="year.value">{{year.text}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">學號</label>
								<div class="col-md-8">
									<input type="text" name="account" v-model="account" class="form-control" />
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">姓名</label>
								<div class="col-md-8">
									<input type="text" name="name" v-model="name" class="form-control" />
								</div>
							</div>
						</div>
					</div>
					<div class="row form-group">
							<div class="col-md-offset-4 col-md-4 ">
								<div class="col-md-offset-4 col-md-4">
									<button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
								</div>
							</div>
						</div>
				</div>
			</div>
		</section>
		<div class="panel-collapse">
			<div class="panel-body">
				<div class="row form-group" >
					<div class="col-md-12 text-right form-inline"></div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<table class="table table-no-more table-bordered table-striped mb-none" >
							<thead>
								<tr>
									<th class="text-center" width="8%"></th>
									<th class="text-center" width="8%">學期</th>
									<th class="text-center" width="10%">學制</th>
									<th class="text-center" width="16%">系科年級</th>
									<th class="text-center" width="8%">學號</th>
									<th class="text-center" width="8%">姓名</th> 
									<th class="text-center" width="10%">申請銷點概況</th>
									<th class="text-center" width="10%">(扣)點數</th> 
									<th class="text-center" width="16%">記錄日期</th> 
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in violateRecordGrid.rows" :key="index">
									<td data-title="" class="text-center">
										<a v-if="!item.violatePoint && item.crUser == sessionData.account" href="javascript:;" class="btn-link">刪除</a>
									</td>
									<td data-title="學期" class="text-center">{{item.smtr}}</td>
									<td data-title="學制" class="text-center">{{item.deptSsymStr}}</td>
									<td data-title="系科年級" class="text-center">
										<span v-if="item.deptCode">{{item.deptCodeStr}}-{{item.drade}}年{{item.dradeClass}}班</span>
									</td>
									<td data-title="學號" class="text-center">{{item.account}}</td>
									<td data-title="姓名" class="text-center">{{item.name}}</td>
									<td data-title="申請銷點概況" class="text-center">
										<a href="javascript:;" class="btn-link" @click="gotoView('stay.deduct.edit', {editType:'E', sno:item.sno, account:item.account, smtr:item.smtr, dormitoryType:item.dormitoryType})">
											{{item.violateName}}
										</a>
									</td>
									<td data-title="(扣)點數" class="text-center">
										<span v-if="!item.violatePoint">--</span>
										<span v-else>{{item.violatePoint}}</span>
									</td>
									<td data-title="記錄日期" class="text-center">{{customFormatter(item.crDate, "YYYY/MM/DD HH:mm:ss")}}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-md-12">
						<div class="text-center" >
							<pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
export default {
	data(){
		return {
			smtr:"",
			account:"",
			name:"",
			totalPoint:0,
			violateRecordGrid:{},
			page:1,
			pageSize:10,
			totalPage:0
		}
	},
	mounted(){
		this.gridInit();
	},
	methods:{
		updateGrid(page) {
			//更新Grid 必需
			this.page = page;
			this.gridInit();
		},
		gridInit(){
			let param = {
				page:this.page,
				pageSize:this.pageSize,
				model:{
					smtr:this.smtr,
					account:this.account,
					name:this.name,
					revokeApply:"Y"
				}
			};
			const api = "/api/Violate/violateRecordGrid";
			this.$axios.post(api, JSON.stringify(param)).then(resp =>{
				this.violateRecordGrid = resp.data.data;
				this.totalPage = this.violateRecordGrid.total
				this.page = this.violateRecordGrid.page;
				this.pageSize = this.violateRecordGrid.pageSize;
			});
		},
		selectYear(){
			let smtrArray = [];
			let nowYear = (new Date().getFullYear() - 1911);
			let nowMonth = new Date().getMonth() + 1;
			if(nowMonth < 8){
				nowYear = nowYear-1;
			}
			for(let y = nowYear; y > 100 ; y--){
				if((y == nowYear && nowMonth < 8) || y < nowYear){
					smtrArray.push({text:y+"年第二學期",value:y+"2"});
				}
				smtrArray.push({text:y+"年第一學期",value:y+"1"});
			}
			return smtrArray;
		},
	},
	beforeRouteLeave(to, from, next) {
		if(to.name != "stay.deduct.edit"){
			this.removeStore(this.$route.name);
		}
		next();
	}
}
</script>